const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.HorseServiceSimpleClient = function HorseServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.getHorse = this.getHorse.bind(this);
  this.listHorses = this.listHorses.bind(this);
  this.assignHorseToBarn = this.assignHorseToBarn.bind(this);
  this.unassignHorseFromBarn = this.unassignHorseFromBarn.bind(this);
  this.assignHorseToFacility = this.assignHorseToFacility.bind(this);
  this.assignHorseToStall = this.assignHorseToStall.bind(this);
  this.unassignHorseFromStall = this.unassignHorseFromStall.bind(this);
  this.assignHorseToTrainer = this.assignHorseToTrainer.bind(this);
  this.unassignHorseFromTrainer = this.unassignHorseFromTrainer.bind(this);
  this.assignPreferredConditionsHorse =
    this.assignPreferredConditionsHorse.bind(this);
  this.resetPreferredConditionsHorse =
    this.resetPreferredConditionsHorse.bind(this);
  this.editHorseHealthWatchStatus = this.editHorseHealthWatchStatus.bind(this);
  this.setHorseWarningMessage = this.setHorseWarningMessage.bind(this);
  this.resetHorseWarningMessage = this.resetHorseWarningMessage.bind(this);
  this.pullRelevantHorseWarningMessage =
    this.pullRelevantHorseWarningMessage.bind(this);
  this.pullHorsesCountByFacilitySummary =
    this.pullHorsesCountByFacilitySummary.bind(this);
  this.pullTrainerHorsesWithMatchingRacesCount =
    this.pullTrainerHorsesWithMatchingRacesCount.bind(this);
  this.pullHorsesCountGroupedByPreferredConditions =
    this.pullHorsesCountGroupedByPreferredConditions.bind(this);
  this.listHorseRisks = this.listHorseRisks.bind(this);
  this.createHorseRisk = this.createHorseRisk.bind(this);
  this.deleteHorseRisk = this.deleteHorseRisk.bind(this);
  this.listRiskFactors = this.listRiskFactors.bind(this);
  this.listHorseInjuries = this.listHorseInjuries.bind(this);
  this.listHorseInjuryDetails = this.listHorseInjuryDetails.bind(this);
  this.listHorseOnLists = this.listHorseOnLists.bind(this);
  this.pullHorsesFromListsCount = this.pullHorsesFromListsCount.bind(this);
  this.pullHorsePreferredConditions =
    this.pullHorsePreferredConditions.bind(this);
  this.createHorseNotepadComment = this.createHorseNotepadComment.bind(this);
  this.updateHorseNotepadComment = this.updateHorseNotepadComment.bind(this);
  this.listHorseNotepadComments = this.listHorseNotepadComments.bind(this);
  this.deleteHorseNotepadComment = this.deleteHorseNotepadComment.bind(this);
  this.pullHorseAggregatedComments =
    this.pullHorseAggregatedComments.bind(this);
  this.markHorseAggregatedCommentsAsRead =
    this.markHorseAggregatedCommentsAsRead.bind(this);
  this.createHorseGeneralVetComment =
    this.createHorseGeneralVetComment.bind(this);
  this.updateHorseGeneralVetComment =
    this.updateHorseGeneralVetComment.bind(this);
  this.deleteHorseGeneralVetComment =
    this.deleteHorseGeneralVetComment.bind(this);
  this.getHorseGeneralVetComment = this.getHorseGeneralVetComment.bind(this);
  this.pullHorsesOrTrainersByName = this.pullHorsesOrTrainersByName.bind(this);
  this.setHorseFlagOnTrack = this.setHorseFlagOnTrack.bind(this);
  this.editHorseFlagOnTrack = this.editHorseFlagOnTrack.bind(this);
  this.resetHorseFlagOnTrack = this.resetHorseFlagOnTrack.bind(this);
  this.deleteHorseFlagOnTrack = this.deleteHorseFlagOnTrack.bind(this);
  this.getHorseFlagOnTrackComment = this.getHorseFlagOnTrackComment.bind(this);
  this.listHorseFlagOnTrackComments =
    this.listHorseFlagOnTrackComments.bind(this);
  this.deleteHorseFlagOnTrackComment =
    this.deleteHorseFlagOnTrackComment.bind(this);
  this.pullInventoryAnalytics = this.pullInventoryAnalytics.bind(this);
  this.pullHorsesShortInfo = this.pullHorsesShortInfo.bind(this);
};
const methodInfo_HorseService_GetHorse = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/GetHorse",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetHorseRequest,
  imports.stronachgroup.first.racehorse360.Horse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.Horse.decode
);
module.exports.HorseServiceSimpleClient.prototype.getHorse = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetHorseRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.HorseService/GetHorse",
    message,
    metadata || {},
    methodInfo_HorseService_GetHorse
  );
};
const methodInfo_HorseService_ListHorses = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListHorses",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListHorsesRequest,
  imports.stronachgroup.first.racehorse360.ListHorsesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListHorsesResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.listHorses = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListHorsesRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/ListHorses",
    message,
    metadata || {},
    methodInfo_HorseService_ListHorses
  );
};
const methodInfo_HorseService_AssignHorseToBarn = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/AssignHorseToBarn",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.AssignHorseToBarnRequest,
  imports.stronachgroup.first.racehorse360.Horse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.Horse.decode
);
module.exports.HorseServiceSimpleClient.prototype.assignHorseToBarn = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.AssignHorseToBarnRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/AssignHorseToBarn",
    message,
    metadata || {},
    methodInfo_HorseService_AssignHorseToBarn
  );
};
const methodInfo_HorseService_UnassignHorseFromBarn =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromBarn",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.unassignHorseFromBarn =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromBarn",
      message,
      metadata || {},
      methodInfo_HorseService_UnassignHorseFromBarn
    );
  };
const methodInfo_HorseService_AssignHorseToFacility =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToFacility",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.assignHorseToFacility =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToFacility",
      message,
      metadata || {},
      methodInfo_HorseService_AssignHorseToFacility
    );
  };
const methodInfo_HorseService_AssignHorseToStall =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToStall",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AssignHorseToStallRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.assignHorseToStall =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AssignHorseToStallRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToStall",
      message,
      metadata || {},
      methodInfo_HorseService_AssignHorseToStall
    );
  };
const methodInfo_HorseService_UnassignHorseFromStall =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromStall",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.unassignHorseFromStall =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromStall",
      message,
      metadata || {},
      methodInfo_HorseService_UnassignHorseFromStall
    );
  };
const methodInfo_HorseService_AssignHorseToTrainer =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToTrainer",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.assignHorseToTrainer =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToTrainer",
      message,
      metadata || {},
      methodInfo_HorseService_AssignHorseToTrainer
    );
  };
const methodInfo_HorseService_UnassignHorseFromTrainer =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromTrainer",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.unassignHorseFromTrainer =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromTrainer",
      message,
      metadata || {},
      methodInfo_HorseService_UnassignHorseFromTrainer
    );
  };
const methodInfo_HorseService_AssignPreferredConditionsHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignPreferredConditionsHorse",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.assignPreferredConditionsHorse =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignPreferredConditionsHorse",
      message,
      metadata || {},
      methodInfo_HorseService_AssignPreferredConditionsHorse
    );
  };
const methodInfo_HorseService_ResetPreferredConditionsHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetPreferredConditionsHorse",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.resetPreferredConditionsHorse =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetPreferredConditionsHorse",
      message,
      metadata || {},
      methodInfo_HorseService_ResetPreferredConditionsHorse
    );
  };
const methodInfo_HorseService_EditHorseHealthWatchStatus =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/EditHorseHealthWatchStatus",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.editHorseHealthWatchStatus =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseHealthWatchStatus",
      message,
      metadata || {},
      methodInfo_HorseService_EditHorseHealthWatchStatus
    );
  };
const methodInfo_HorseService_SetHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/SetHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.setHorseWarningMessage =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseWarningMessage",
      message,
      metadata || {},
      methodInfo_HorseService_SetHorseWarningMessage
    );
  };
const methodInfo_HorseService_ResetHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.resetHorseWarningMessage =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseWarningMessage",
      message,
      metadata || {},
      methodInfo_HorseService_ResetHorseWarningMessage
    );
  };
const methodInfo_HorseService_PullRelevantHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullRelevantHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest,
    imports.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullRelevantHorseWarningMessage =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullRelevantHorseWarningMessage",
      message,
      metadata || {},
      methodInfo_HorseService_PullRelevantHorseWarningMessage
    );
  };
const methodInfo_HorseService_PullHorsesCountByFacilitySummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountByFacilitySummary",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest,
    imports.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsesCountByFacilitySummary =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountByFacilitySummary",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsesCountByFacilitySummary
    );
  };
const methodInfo_HorseService_PullTrainerHorsesWithMatchingRacesCount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullTrainerHorsesWithMatchingRacesCount",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest,
    imports.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullTrainerHorsesWithMatchingRacesCount =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullTrainerHorsesWithMatchingRacesCount",
      message,
      metadata || {},
      methodInfo_HorseService_PullTrainerHorsesWithMatchingRacesCount
    );
  };
const methodInfo_HorseService_PullHorsesCountGroupedByPreferredConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountGroupedByPreferredConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsesCountGroupedByPreferredConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountGroupedByPreferredConditions",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsesCountGroupedByPreferredConditions
    );
  };
const methodInfo_HorseService_ListHorseRisks = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListHorseRisks",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListHorseRisksRequest,
  imports.stronachgroup.first.racehorse360.ListHorseRisksResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListHorseRisksResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.listHorseRisks = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListHorseRisksRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/ListHorseRisks",
    message,
    metadata || {},
    methodInfo_HorseService_ListHorseRisks
  );
};
const methodInfo_HorseService_CreateHorseRisk = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/CreateHorseRisk",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.CreateHorseRiskRequest,
  imports.stronachgroup.first.racehorse360.HorseRisk,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.HorseRisk.decode
);
module.exports.HorseServiceSimpleClient.prototype.createHorseRisk = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.CreateHorseRiskRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/CreateHorseRisk",
    message,
    metadata || {},
    methodInfo_HorseService_CreateHorseRisk
  );
};
const methodInfo_HorseService_DeleteHorseRisk = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/DeleteHorseRisk",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.DeleteHorseRiskRequest,
  imports.stronachgroup.first.racehorse360.EmptyResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.EmptyResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.deleteHorseRisk = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.DeleteHorseRiskRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/DeleteHorseRisk",
    message,
    metadata || {},
    methodInfo_HorseService_DeleteHorseRisk
  );
};
const methodInfo_HorseService_ListRiskFactors = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListRiskFactors",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListRiskFactorsRequest,
  imports.stronachgroup.first.racehorse360.ListRiskFactorsResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListRiskFactorsResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.listRiskFactors = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListRiskFactorsRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/ListRiskFactors",
    message,
    metadata || {},
    methodInfo_HorseService_ListRiskFactors
  );
};
const methodInfo_HorseService_ListHorseInjuries = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuries",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListHorseInjuriesRequest,
  imports.stronachgroup.first.racehorse360.ListHorseInjuriesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListHorseInjuriesResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.listHorseInjuries = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListHorseInjuriesRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuries",
    message,
    metadata || {},
    methodInfo_HorseService_ListHorseInjuries
  );
};
const methodInfo_HorseService_ListHorseInjuryDetails =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuryDetails",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.listHorseInjuryDetails =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuryDetails",
      message,
      metadata || {},
      methodInfo_HorseService_ListHorseInjuryDetails
    );
  };
const methodInfo_HorseService_ListHorseOnLists = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListHorseOnLists",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListHorseOnListsRequest,
  imports.stronachgroup.first.racehorse360.ListHorseOnListsResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListHorseOnListsResponse.decode
);
module.exports.HorseServiceSimpleClient.prototype.listHorseOnLists = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListHorseOnListsRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseService/ListHorseOnLists",
    message,
    metadata || {},
    methodInfo_HorseService_ListHorseOnLists
  );
};
const methodInfo_HorseService_PullHorsesFromListsCount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesFromListsCount",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest,
    imports.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsesFromListsCount =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesFromListsCount",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsesFromListsCount
    );
  };
const methodInfo_HorseService_PullHorsePreferredConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsePreferredConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsePreferredConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsePreferredConditions",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsePreferredConditions
    );
  };
const methodInfo_HorseService_CreateHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/CreateHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseNotepadComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseNotepadComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.createHorseNotepadComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseNotepadComment",
      message,
      metadata || {},
      methodInfo_HorseService_CreateHorseNotepadComment
    );
  };
const methodInfo_HorseService_UpdateHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UpdateHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseNotepadComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseNotepadComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.updateHorseNotepadComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseNotepadComment",
      message,
      metadata || {},
      methodInfo_HorseService_UpdateHorseNotepadComment
    );
  };
const methodInfo_HorseService_ListHorseNotepadComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseNotepadComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.listHorseNotepadComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseNotepadComments",
      message,
      metadata || {},
      methodInfo_HorseService_ListHorseNotepadComments
    );
  };
const methodInfo_HorseService_DeleteHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.deleteHorseNotepadComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseNotepadComment",
      message,
      metadata || {},
      methodInfo_HorseService_DeleteHorseNotepadComment
    );
  };
const methodInfo_HorseService_PullHorseAggregatedComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorseAggregatedComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest,
    imports.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorseAggregatedComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorseAggregatedComments",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorseAggregatedComments
    );
  };
const methodInfo_HorseService_MarkHorseAggregatedCommentsAsRead =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/MarkHorseAggregatedCommentsAsRead",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.markHorseAggregatedCommentsAsRead =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/MarkHorseAggregatedCommentsAsRead",
      message,
      metadata || {},
      methodInfo_HorseService_MarkHorseAggregatedCommentsAsRead
    );
  };
const methodInfo_HorseService_CreateHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/CreateHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.createHorseGeneralVetComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseGeneralVetComment",
      message,
      metadata || {},
      methodInfo_HorseService_CreateHorseGeneralVetComment
    );
  };
const methodInfo_HorseService_UpdateHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UpdateHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.updateHorseGeneralVetComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseGeneralVetComment",
      message,
      metadata || {},
      methodInfo_HorseService_UpdateHorseGeneralVetComment
    );
  };
const methodInfo_HorseService_DeleteHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.deleteHorseGeneralVetComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseGeneralVetComment",
      message,
      metadata || {},
      methodInfo_HorseService_DeleteHorseGeneralVetComment
    );
  };
const methodInfo_HorseService_GetHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/GetHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseGeneralVetComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.getHorseGeneralVetComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseGeneralVetComment",
      message,
      metadata || {},
      methodInfo_HorseService_GetHorseGeneralVetComment
    );
  };
const methodInfo_HorseService_PullHorsesOrTrainersByName =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesOrTrainersByName",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest,
    imports.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsesOrTrainersByName =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesOrTrainersByName",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsesOrTrainersByName
    );
  };
const methodInfo_HorseService_SetHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/SetHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.setHorseFlagOnTrack =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseFlagOnTrack",
      message,
      metadata || {},
      methodInfo_HorseService_SetHorseFlagOnTrack
    );
  };
const methodInfo_HorseService_EditHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/EditHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.editHorseFlagOnTrack =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseFlagOnTrack",
      message,
      metadata || {},
      methodInfo_HorseService_EditHorseFlagOnTrack
    );
  };
const methodInfo_HorseService_ResetHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest,
    imports.stronachgroup.first.racehorse360.Horse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Horse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.resetHorseFlagOnTrack =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseFlagOnTrack",
      message,
      metadata || {},
      methodInfo_HorseService_ResetHorseFlagOnTrack
    );
  };
const methodInfo_HorseService_DeleteHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.deleteHorseFlagOnTrack =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrack",
      message,
      metadata || {},
      methodInfo_HorseService_DeleteHorseFlagOnTrack
    );
  };
const methodInfo_HorseService_GetHorseFlagOnTrackComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/GetHorseFlagOnTrackComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseFlagOnTrackComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.decode
  );
module.exports.HorseServiceSimpleClient.prototype.getHorseFlagOnTrackComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseFlagOnTrackComment",
      message,
      metadata || {},
      methodInfo_HorseService_GetHorseFlagOnTrackComment
    );
  };
const methodInfo_HorseService_ListHorseFlagOnTrackComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseFlagOnTrackComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.listHorseFlagOnTrackComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseFlagOnTrackComments",
      message,
      metadata || {},
      methodInfo_HorseService_ListHorseFlagOnTrackComments
    );
  };
const methodInfo_HorseService_DeleteHorseFlagOnTrackComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrackComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.deleteHorseFlagOnTrackComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrackComment",
      message,
      metadata || {},
      methodInfo_HorseService_DeleteHorseFlagOnTrackComment
    );
  };
const methodInfo_HorseService_PullInventoryAnalytics =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullInventoryAnalytics",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest,
    imports.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullInventoryAnalytics =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullInventoryAnalytics",
      message,
      metadata || {},
      methodInfo_HorseService_PullInventoryAnalytics
    );
  };
const methodInfo_HorseService_PullHorsesShortInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesShortInfo",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest,
    imports.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse.decode
  );
module.exports.HorseServiceSimpleClient.prototype.pullHorsesShortInfo =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesShortInfo",
      message,
      metadata || {},
      methodInfo_HorseService_PullHorsesShortInfo
    );
  };
